/**
 * Auflistung der funktionalen Rollen einer Organisation
 * @type {({title: string, key: string}|{title: string, key: string}|{title: string, key: string})[]}
 */
import {
    BEAUFTRAGTER,
    BETREIBER,
    FACHADMIN,
    LESER_BEHOERDE,
    LESER_ORGANISATION,
    SYSTEMADMIN,
    ZUST_SBA,
    ZUST_SBB,
    ZUST_SBD,
    ZUST_SBS,
} from "./funktionaleRollen";

const funktionaleRollenOrganisation = [
    {
        title: "Betreiber",
        key: "BETREIBER",
    },
    {
        title: "Beauftragter",
        key: "BEAUFTRAGTER",
    },
    {
        title: "Leser (Organisation)",
        key: "LESER_ORGANISATION",
    },
];

/**
 * Die verschiedenen Status von Betrieben und Messstellen
 * @type {({id: string, value: string}|{id: string, value: string}|{id: string, value: string})[]}
 */
export const statusOptionen = [
    {id: "GEPLANT", value: "geplant"},
    {id: "IN_BETRIEB", value: "in Betrieb"},
    {id: "STILLGELEGT", value: "stillgelegt"},
];

/**
 * Optionen für die Auswahl von Einleiter-Arten
 * @type {[{id: number, value: string}, {id: number, value: string}, {id: number, value: string}]}
 */
export const einleiterOptionen = [
    {id: 1, value: "Alle Anlagen"},
    {id: 2, value: "Indirekteinleiter"},
    {id: 3, value: "Direkteinleiter"},
];

const funktionaleRollen = [
    BETREIBER,
    BEAUFTRAGTER,
    LESER_ORGANISATION,
    ZUST_SBD,
    ZUST_SBB,
    ZUST_SBS,
    ZUST_SBA,
    LESER_BEHOERDE,
    FACHADMIN,
    SYSTEMADMIN,
];

const funktionaleRollenAsObjects = [
    {id: BETREIBER, value: "Betreiber"},
    {id: BEAUFTRAGTER, value: "Beauftragter"},
    {id: LESER_ORGANISATION, value: "Leser (Betreiber)"},
    {id: ZUST_SBD, value: "ZustSBD"},
    {id: ZUST_SBB, value: "ZustSBB"},
    {id: ZUST_SBS, value: "ZustSBS"},
    {id: ZUST_SBA, value: "ZustSBA"},
    {id: LESER_BEHOERDE, value: "Leser (Behörde)"},
    {id: FACHADMIN, value: "Fachadministrator"},
    {id: SYSTEMADMIN, value: "Systemadministrator"},
];

function getFunktionaleRolleByID(id) {
    return funktionaleRollenAsObjects.find((funktionaleRolle) => funktionaleRolle.id === id);
}

/**
 * Gibt die möglichen funktionalen Rollen der ID der globalen Rolle zurück
 * @param globaleRolle
 * @returns {[{id: string, value: string}, {id: string, value: string}, {id: string, value: string}]|[{id: string, value: string}, {id: string, value: string}, {id: string, value: string}, {id: string, value: string}, {id: string, value: string}]|[{id: string, value: string}, {id: string, value: string}]|*[]}
 */
export const getFunktionaleRollenByGlobaleRolle = (globaleRolle) => {
    switch (globaleRolle) {
        case GLOBALE_ROLLE_ORGANISATION:
            return [
                {id: BETREIBER, value: "Betreiber"},
                {id: BEAUFTRAGTER, value: "Beauftragter"},
                {id: LESER_ORGANISATION, value: "Leser (Betreiber)"},
            ];
        case GLOBALE_ROLLE_BEHOERDE:
            return [
                {id: ZUST_SBD, value: "ZustSBD"},
                {id: ZUST_SBB, value: "ZustSBB"},
                {id: ZUST_SBS, value: "ZustSBS"},
                {id: ZUST_SBA, value: "ZustSBA"},
                {id: LESER_BEHOERDE, value: "Leser (Behörde)"},
            ];
        case GLOBALE_ROLLE_ADMIN:
            return [
                {id: FACHADMIN, value: "Fachadministrator"},
                {id: SYSTEMADMIN, value: "Systemadministrator"},
            ];
        default:
            return [];
    }
};

export const GLOBALE_ROLLE_ADMIN = "ADMIN";
export const GLOBALE_ROLLE_ORGANISATION = "ORGANISATION";
export const GLOBALE_ROLLE_BEHOERDE = "BEHOERDE";

const globaleRollen = [
    {key: GLOBALE_ROLLE_ORGANISATION, title: "Organisation", id: GLOBALE_ROLLE_ORGANISATION, value: "Organisation"},
    {key: GLOBALE_ROLLE_BEHOERDE, title: "Behörde", id: GLOBALE_ROLLE_BEHOERDE, value: "Behörde"},
    {key: GLOBALE_ROLLE_ADMIN, title: "Administration", id: GLOBALE_ROLLE_ADMIN, value: "Administration"},
];

export {globaleRollen, funktionaleRollen, funktionaleRollenAsObjects, getFunktionaleRolleByID, funktionaleRollenOrganisation};

export const JahresberichtValues = [
    {
        id: "IN_BEARBEITUNG",
        value: "In Bearbeitung",
    },
    {
        id: "EINGEREICHT",
        value: "Eingereicht",
    },
    {
        id: "PLAUSIBILISIERT",
        value: "Plausibilisiert"
    }
];

export const StatusAQSValues = [
    {
        id: "UNBEARBEITET",
        value: "Unbearbeitet",
    },
    {
        id: "NICHT_ERFORDERLICH",
        value: "Nicht erforderlich",
    },
    {
        id: "ABGESCHLOSSEN",
        value: "Abgeschlossen"
    }
];

export const StatusExterneValues = [
    {
        id: "UNBEARBEITET",
        value: "Unbearbeitet",
    },
    {
        id: "NICHT_ERFORDERLICH",
        value: "Nicht erforderlich",
    },
    {
        id: "ABGESCHLOSSEN",
        value: "Abgeschlossen"
    }
];

export const StatusParameterMesswerte = [
    {
        id: "ABGESCHLOSSEN",
        value: "Abgeschlossen"
    },
    {
        id: "IN_BEARBEITUNG",
        value: "In Bearbeitung"
    },
    {
        id: "UNBEARBEITET",
        value: "Unbearbeitet"
    },
    {
        id: "IMPORTIERT",
        value: "Importiert"
    }
];

export const KanalzustandValues = [
    {
        id: "ENTFAELLT",
        value: "Entfällt"
    },
    {
        id: "ANGEFORDERT",
        value: "Angefordert"
    },
    {
        id: "UEBERMITTELT",
        value: "Übermittelt"
    }
];

export const DurchflusspruefungValues = [
    {
        id: "ENTFAELLT",
        value: "Entfällt"
    },
    {
        id: "ZU_ABLAUF",
        value: "Zu-/Ablauf"
    },
    {
        id: "ZULAUF",
        value: "Zulauf"
    },
    {
        id: "ABLAUF",
        value: "Ablauf"
    }
];
